/**
 * The brand hero composition: the solid mark over its construction keylines, the same drawing as
 * the marketing site's hero (apps/site/src/pages/home.ts) and the social card
 * (.orgus-dev/tmp/brand/final/og-image.html).
 *
 * The keylines are open lines that run past the frame on the mark's 32-unit grid: the frame
 * edges (2 and 30) and the centre axes (16). No enclosing square, no circles, no diagonals.
 * Drawn first, so the mark sits on top and they show only through the seams, the core's court
 * and around it. keylines.test.ts fails if this drifts from the site's copy.
 */
export const ORGUS_KEYLINES = {
  /** 44 units: the 28-unit frame plus 8 units of keyline run on each side of the 32 grid. */
  viewBox: '-6 -6 44 44',
  /** The centre axes. */
  axes: 'M-6 16H38M16 -6V38',
  /** The frame's edges, run on past it. */
  frame: 'M2 -6V38M30 -6V38M-6 2H38M-6 30H38',
  strokeWidth: 0.09,
  /** The frame lines sit a step back from the axes. */
  frameOpacity: 0.55,
  /** Keyline colour: Sapphire 300 (accent text on the dark field) at 30%, as on the site. */
  colour: 'color-mix(in oklab, var(--accent-text) 30%, transparent)',
} as const;
